import React, { Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-modal';
import customStylesModal from '../../booking/components/CustomStylesModal';
import Cards from '../../common/cards/Cards';
import { confirmAlert } from 'react-confirm-alert';
import withRouter from 'components/components/common/withRouter';
import ReservationStatusHelper from 'components/common/helpers/ReservationStatusHelper';
import { connect } from 'react-redux';
import {
  setReservationToEdit,
  resetReservationUpdateData,
  createSuccessNotification,
  createErrorNotification,
  cancelReservation
} from 'components/actions/serviceActions';
import mergeErrors from 'components/helpers/mergeErrors';
import axios from 'components/AppRequest';
import FlightHelper from 'components/common/helpers/FlightHelper';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import moment from 'moment';

class NotificationButtons extends React.Component {

  state = {
    isSaving: false,
  }

  gotoEdit = () => {
    this.props.resetReservationUpdateData();
    this.props.setReservationToEdit(this.props.reservation);
    TransHelper.redirect(
      this.props,
      'routes.url.dashboardEdit',
      { 'id': this.props.reservation.id }
    );
  }

  trans = (key, vars = null, prefix = 'content.dashboard.notificationButtons') => {
    return TransHelper.translate(this.props.locale, prefix + "." + key, vars);
  }

  transNotify = (key) => {
    return this.trans(key, null, 'content.notifications.notificationButtons');
  }

  getRefundInfo() {
    var flight = this.props.reservation.flight;
    var flightDate = moment(flight.flight_date);
    var before8h = moment(flight.flight_date).subtract(8, 'hours');
    var now = moment();
    if ((now >= before8h && now <= flightDate) || now >= flightDate) {
      return this.trans('infoWithoutRefundNotification');
    } else {
      return this.trans('refundInfo');
    }
  }

  cancelBooking = (onClose) => {
    if (this.state.isSaving) {
      return;
    }

    const { reservation } = this.props;
    var params = {
      data: {
        id: reservation.id,
        type: reservation.reservation_type,
        reservation_direction: reservation.reservation_direction
      }
    };
    this.setState({ isSaving: true }, () => {
      axios.post('/pwa/reservation/cancel/' + reservation.id, params)
        .then(response => {
          this.props.cancelReservation(
            reservation.id,
            reservation.reservation_direction,
            reservation.reservation_type,
            response.data.cancelled_with_refund
          );
          this.setState({ isSaving: false });
          this.props.createSuccessNotification({ message: this.transNotify('cancelSuccess') });
          onClose();
        })
        .catch(err => {
          this.setState({ isSaving: false });
          onClose();
          var mergedErrors = mergeErrors(err.response.data.errors);
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: mergedErrors
          });
        });
    })
  }

  onClickCancel = (e) => {
    e.preventDefault();
    const { locale, reservation } = this.props;
    var flightHelper = new FlightHelper(
      reservation.flight,
      locale,
      reservation.reservation_direction
    );
    var message = this.trans(
      'cancelBooking.message',
      {
        'on': flightHelper.getFlightDateAsString(locale),
        'from': flightHelper.getFrom(),
        'to': flightHelper.getTo()
      }
    );
    var title = this.trans('cancelBooking.title');

    const options = {
      title: title,
      message: message,
      willUnmount: () => { },
      customUI: ({ title, message, onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <div className='react-confirm-header'>
              <FontAwesomeIcon
                icon={['far', 'frown']}
                size="2x"
              />
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
            </div>

            <div className='react-confirm-desc'>
              <p>{message}</p>
            </div>

            <div className='react-confirm-alert-button-group'>
              <button
                className="button btn-remove"
                disabled={this.state.isSaving}
                onClick={() => { this.cancelBooking(onClose); }}
              >
                {this.trans('cancelBookingConfirm')}
              </button>
              <button
                className="button btn-cancel"
                disabled={this.state.isSaving}
                onClick={onClose}
              >
                {this.trans('cancelBookingText')}
              </button>
            </div>
            <p className='react-confirm-note'>
              {this.getRefundInfo()}
            </p>
            <button
              onClick={onClose}
              title={this.trans('closeTitle')}
              className="react-confirm-close"
            >
              <FontAwesomeIcon
                icon={['fas', 'times']}
                size="2x"
              />
            </button>
          </div>
        )
      }
    };
    confirmAlert(options);
  }

  render() {
    var helper = new ReservationStatusHelper(this.props.reservation);
    return (
      <div className="nav-bottom__buttons">
        <ul className="nav-page">

          <li className="nav-page__item">
            {helper.canCustomerCancel() &&
              <button
                className="button button--outline"
                onClick={this.onClickCancel}
                disabled={helper.disableCancel()}
              >
                {/* Cancel<span style={{ marginLeft: ' 5px'}}>booking</span> */}
                <T>content.dashboard.notificationButtons.cancel</T>
                <span style={{ marginLeft: ' 5px' }}>
                  <T>content.dashboard.notificationButtons.booking</T>
                </span>
              </button>
            }
          </li>

          <li className="nav-page__item">
            {helper.canShowEdit() && (
              <Fragment>
                {!helper.canCustomerEdit() &&
                  <span className="not-allowed">
                    <button className="button" disabled>
                      <FontAwesomeIcon
                        icon={['fas', 'lock']}
                        size="xs"
                        className="lock"
                      />
                      <T>content.dashboard.notificationButtons.editButton</T>
                    </button>
                  </span>
                }

                {helper.canCustomerEdit() &&
                  <button
                    className="button"
                    onClick={this.gotoEdit}
                  >
                    <T>content.dashboard.notificationButtons.editButton</T>
                  </button>
                }
              </Fragment>
            )}
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  };
};

export default withRouter(
  connect(mapStateToProps,
    {
      setReservationToEdit,
      resetReservationUpdateData,
      createSuccessNotification,
      createErrorNotification,
      cancelReservation
    })(NotificationButtons)
);
